import ReactApexChart from "react-apexcharts";
import { Row, Col, Typography } from "antd";
import { formatCurrency } from "../../services/dashboardService";

function EChart({ monthlyDividendData }) {
  const { Title, Paragraph } = Typography;

  // 월별 배당금 데이터가 없는 경우 기본값 설정
  const categories = monthlyDividendData?.categories || [];
  const amounts = monthlyDividendData?.amounts || [];

  // 차트 옵션 설정
  const chartOptions = {
    chart: {
      type: 'bar',
      height: 220,
      toolbar: {
        show: false,
      },
      background: '#f8f9fa',
      dropShadow: {
        enabled: true,
        top: 3,
        left: 2,
        blur: 4,
        opacity: 0.1,
      }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '65%',
        endingShape: 'rounded',
        borderRadius: 8,
        dataLabels: {
          position: 'top',
        }
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: categories,
      labels: {
        style: {
          colors: '#8c8c8c',
          fontSize: '12px',
        },
      },
    },
    yaxis: {
      title: {
        text: '배당금 (원)',
        style: {
          color: '#8c8c8c',
        },
      },
      labels: {
        style: {
          colors: '#8c8c8c',
        },
        formatter: function (val) {
          return val ? `${(val / 10000).toFixed(0)}만` : '0';
        },
      },
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'light',
        type: 'vertical',
        shadeIntensity: 0.3,
        gradientToColors: ['#95de64'],
        inverseColors: false,
        opacityFrom: 0.9,
        opacityTo: 0.7,
        stops: [0, 100]
      }
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return formatCurrency(val);
        },
      },
      theme: 'light',
      style: {
        fontSize: '12px',
        fontFamily: undefined
      }
    },
    grid: {
      borderColor: '#f0f0f0',
      strokeDashArray: 1,
      xaxis: {
        lines: {
          show: true
        }
      },
      yaxis: {
        lines: {
          show: true
        }
      },
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      }
    },
    colors: ['#52c41a'],
  };

  const chartSeries = [
    {
      name: '월별 배당금',
      data: amounts,
    },
  ];

  // 통계 계산
  const totalDividends = amounts.reduce((sum, amount) => sum + amount, 0);
  const avgMonthlyDividend = amounts.length > 0 ? totalDividends / amounts.length : 0;
  const maxMonthlyDividend = amounts.length > 0 ? Math.max(...amounts) : 0;
  const recentMonthDividend = amounts.length > 0 ? amounts[amounts.length - 1] : 0;

  const stats = [
    {
      Title: formatCurrency(totalDividends).replace('₩', ''),
      user: "총 배당금",
    },
    {
      Title: formatCurrency(avgMonthlyDividend).replace('₩', ''),
      user: "월평균",
    },
    {
      Title: formatCurrency(maxMonthlyDividend).replace('₩', ''),
      user: "최고월",
    },
    {
      Title: formatCurrency(recentMonthDividend).replace('₩', ''),
      user: "이번달",
    },
  ];

  return (
    <>
      <div id="chart">
        <ReactApexChart
          className="bar-chart"
          options={chartOptions}
          series={chartSeries}
          type="bar"
          height={220}
        />
      </div>
      <div className="chart-vistior">
        <Title level={5}>월별 배당금 수익</Title>
        <Paragraph className="lastweek">
          최근 12개월 <span className="bnb2">배당금 현황</span>
        </Paragraph>
        <Paragraph className="lastweek">
          매월 받는 배당금을 한눈에 확인하고 투자 성과를 분석해보세요.
        </Paragraph>
        <Row gutter>
          {stats.map((v, index) => (
            <Col xs={6} xl={6} sm={6} md={6} key={index}>
              <div className="chart-visitor-count">
                <Title level={4} style={{ fontSize: '16px' }}>{v.Title}</Title>
                <span style={{ fontSize: '12px' }}>{v.user}</span>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </>
  );
}

export default EChart;
